import { render, staticRenderFns } from "./documentHeader.vue?vue&type=template&id=c58989c2"
import script from "./documentHeader.vue?vue&type=script&lang=js"
export * from "./documentHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports